export default {
  suggestions: 'Нет предложений | {n} предложение | {n} предложения | {n} предложений',
};
